module.exports = __webpack_public_path__ + "img/starFeed.1389c077.png";